import RegisterStoreMember from 'components/Register/RegisterStoreMember/RegisterStoreMember';

export default RegisterStoreMember;
